import { goodOnlineApiSlice } from '../api/apiSlice'
import { FetchBankListResponse, ResolveBankAccountResponse } from './misc.types'

export const bankApiSlice = goodOnlineApiSlice.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    fetchBanks: builder.query<FetchBankListResponse, void>({
      query: () => ({
        url: `v1/misc/banks`,
        method: 'GET',
        params: {},
      }),
      providesTags: [{ type: 'BANK', id: 'LIST' }],
    }),
    resolveBankDetails: builder.query<
      ResolveBankAccountResponse,
      {
        accountNumber?: string
        bankCode?: string
      }
    >({
      query: (params) => ({
        url: `v1/misc/banks/resolve`,
        method: 'GET',
        params: params,
      }),
      providesTags: (_result, _error, arg) => [
        { type: 'BANK', id: `RESOLVE-${arg.bankCode}-${arg.accountNumber}` },
      ],
    }),
  }),
})

export const { useFetchBanksQuery, useResolveBankDetailsQuery } = bankApiSlice
